export default {
  general: {
    home: 'Početna',
    save_failed: 'Čuvanje nije uspelo.',
    print: 'Štampaj',
    print_without_discount: 'Štampaj bez popusta',
    informations: 'Informacije',
    dashboard: 'Početna',
    other: 'Ostalo',
    club: 'Sportsko udruženje | Sportska udruženja',
    registration_fee: 'Kotizacija',
    registration_fee_discount: 'Popust kotizacije',
    male: 'Muški',
    female: 'Ženski',
    mixed: 'Muško/Ženski',
    save: 'Sačuvaj',
    save_changes: 'Sačuvaj izmene',
    both: 'Oba',
    men: 'Muškarci',
    women: 'Žene',
    edit: 'Izmeni',
    add: 'Dodaj',
    add_text: 'Dodaj tekst',
    create: 'Napravi',
    actions: 'Akcije',
    next: 'Dalje',
    ops: 'Uuups!',
    prev_step: 'Prethodni korak',
    page_doesnt_exists: 'Strana kojoj pokusašavaš da pristupiš ne postoji.',
    back_to_home: 'Nazad na početnu',
    type: 'Tip',
    cancel: 'Otkazi',
    confirm: 'Potvrdi',
    remove: 'Ukloni',
    warning: 'Upozorenje',
    function: 'Funkcija',
    documents: 'Dokumenta',
    images: 'Slike',
    n0: 'Rb.',
    cover_image: 'Naslovna slika',
    yes: 'Da',
    no: 'Ne',
    change: 'Izmena',
    date: 'Datum',
    close: 'Zatvori',
    isActive: 'Aktivan',
    active: 'Aktivni | Aktiviraj',
    archive: 'Arhiva | Arhiviraj',
    unarchive: 'Aktiviraj',
    delete: 'Obriši',
    alphabetically: 'A-Z',
    latest_first: 'Poslednji pri vrhu',
    oldest_first: 'Stariji pri vrhu',
    by_club: 'Po sportskom udruženju',
    by_assigned_number: 'Po dodeljenom broju',
    order_by: 'Redosled',
    placement: 'Plasman',
    rank: 'Rang',
    points: 'Poeni',
    block: 'Blokiraj',
    unblock: 'Odblokiraj',
    set_as_admin: 'Postavi kao admina',
    remove_as_admin: 'Ukloni admina',
    update_password: 'Izmeni lozinku',
    deleted_user: 'Obrisan korisnik',
    show: 'Prikaži',
    hide: 'Sakrij',
    select_file: 'Izaberi fajl',
    confirm_delete: 'Da li ste sigurni da želite da obrišete {item}?',
    no_history: 'Nema unosa u istoriji.'
  },

  menu: {
    my_club: 'Moje Sportsko Udruženje',
    ranking_list: 'Rang lista',
    ranking_sports_associations: 'Sportska udruženja',
    open_tournament: 'Otvoreni turnir',
    open_seminar: 'Otvoreni seminar',
    open_camp: 'Otvoreni kamp',
    last_tournament: 'Poslednji turnir',
    admin_panel: 'Admin Panel',
    users: 'Korisnici'
  },

  auth: {
    login: 'Prijava',
    log_out: 'Odjavi se',
    register: 'Registracija',
    no_account_register: 'Nemate nalog? Registrujte se',
    have_account_login: 'Imate nalog? Prijavite se',
    sign_in: 'Prijavi se',
    sign_up: 'Registruj se',
    profile_information: 'Informacije Profila',
    club_info: 'Informacije Sportske Organizacije',
    forgot_password: 'Zaboravili ste lozinku?',
    reset_password: 'Resetuj lozinku',
    add_coach: 'Dodaj trenera',
    add_referee: 'Dodaj sudiju',
    edit_coach: 'Izmeni trenera',
    edit_referee: 'Izmeni sudiju',
    add_member: 'Dodaj člana',
    edit_member: 'Izmeni člana'
  },

  form: {
    name: 'Ime',
    first_name: 'Ime',
    last_name: 'Prezime',
    full_name: 'Ime i prezime',
    city: 'Grad',
    address: 'Adresa',
    username: 'Korisničko ime',
    price: 'Cena',
    website: 'Web sajt',
    contact_person: 'Kontakt osoba',
    discount: 'Popust',
    description: 'Opis',
    mobile: 'Mobilni',
    email: 'Email',
    enter_email: 'Unesite email adresu',
    password: 'Lozinka',
    repeat_password: 'Ponovi lozinku',
    enter_password: 'Unesite lozinku',
    image: 'Slika',
    insurance: 'Osiguranje',
    insurance_company: 'Osiguravajuća kuća',
    insurance_validity_start_date: 'Važenje osiguranja - početni datum',
    insurance_validity_end_date: 'Važenje osiguranja - krajnji datum',
    medical_examination: 'Lekarski pregled',
    medical_examination_start_date: 'Početni datum lekarskog pregleda',
    medical_examination_end_date: 'Krajnji datum lekarskog pregleda',
    insurance_document: 'Dokument za osiguranje',
    medical_document: 'Dokument za lekarski pregled',
    other_documents: 'Drugi dokumenti',
    date_of_birth: 'Datum rođenja',
    gender: 'Pol',
    belt: 'Pojas',
    day: 'Dan',
    font_size: 'Veličina fonta',
    font_family: 'Font',
    earned_points: 'Ostvareni poeni',
    add_points: 'Dodaj poene',
    change_history: 'Istorija izmena',
    modified_by: 'Izmenio',
    points_history_manual: 'Ručno dodato poena',
    points_history_unknown: '—',
    points_history_by_user: 'Od strane: {name}',
    points_history_by_system: 'Sistem turnira (automatski)',
    points_history_date_of_change: 'Datum izmene',
    points_history_points_added: 'Dodati poeni',
    points_history_points_change: 'Promena poena (od → do)',
    points_history_basis: 'Osnov (učešće ili plasman)',
    points_history_tournament_name: 'Naziv turnira',
    points_history_category: 'Kategorija',
    points_history_discipline: 'Disciplina'
  },

  tournament: {
    teams: 'Ekipe',
    competitors: 'Takmičar | Takmičari',
    tournament_name: 'Naziv turnira',
    tournament: 'Turnir | Turniri',
    create_tournament: 'Napravi turnir',
    registered_competitors: 'Prijavljeni takmičari',
    all_registered_competitors: 'Svi prijavljeni takmičari',
    all_registered_teams: 'Sve prijavljene ekipe',
    my_registered_competitors: 'Moji prijavljeni takmičari',
    my_registered_teams: 'Moje prijavljene ekipe',
    edit_tournament: 'Izmeni turnir',
    edit_club_name: 'Izmeni sportsko udruzenje',
    registration_start_date: 'Početak prijava',
    registration_end_date: 'Završetak prijava',
    single_disciplines: 'Pojedinačne discipline',
    team_disciplines: 'Ekipne discipline',
    registration_fee_type: 'Tip kotizacije',
    registration_fee_type_placeholder: 'Izaberite…',
    registration_fee_per_discipline: 'Po disciplini',
    registration_fee_bundle: 'Paketna kotizacija',
    registration_fee_legacy: 'Stari način',
    price_per_discipline: 'Cena po disciplini',
    disciplines_or_more: 'disciplina ili više',
    min_disciplines: 'Min. disciplina',
    add_fee_rule: 'Dodaj.',
    bundle_fee_index_and_more: 'i više',
    fee_rules_required: 'Dodajte bar jedno pravilo za paketnu kotizaciju.',
    fee_rules_invalid: 'Svako pravilo mora imati bar 1 disciplinu i nenegativnu cenu i popust.',
    number_of_registered_competitors: 'Broj prijavljenih takmičara',
    number_of_registered_disciplines:
      'Broj prijavljenih pojedinačnih disciplina',
    number_of_registered_team_disciplines:
      'Broj prijavljenih ekipnih disciplina',
    number_of_registered_clubs: 'Broj prijavljenih sportskih udruženja',
    number_of_registered_referees: 'Broj prijavljenih sudija',
    number_of_registered_officials: 'Broj prijavljenih zvaničnika',
    number_of_registered_coaches: 'Broj prijavljenih trenera',
    total_podium_awards_required: 'Ukupno potrebnih nagrada za postolje',
    gold_awards: 'Zlato',
    silver_awards: 'Srebro',
    bronze_awards: 'Bronza',
    ask_delete_tournament: 'Da li si siguran da želiš da obrišeš ovaj turnir',
    register_competitor: 'Prijavi takmičara',
    edit_competitor: 'Izmeni takmičara',
    seeded_competitor: 'Nosilac medalje',
    seeded_competitor_description: 'Nosioci će biti razdvojeni u žrebu i neće se moći sresti u ranim rundama.',
    register_team: 'Prijavi ekipu',
    assign_numbers: 'Dodela brojeva',
    change_history: 'Istorija izmena',
    add_team: 'Dodaj ekipu',
    edit_team: 'Izmeni ekipu',
    open_applications: 'Otvori prijave',
    close_applications: 'Zatvori prijave',
    applications_are_open: 'Prijave su otvorene',
    applications_are_closed: 'Prijave su zaključane',
    general_info: 'Opšti podaci',
    certificates: 'Sertifikati',
    certificate: 'Sertifikat',
    diploma: 'Diploma',
    document_types: 'Tipovi dokumenata',
    no_document_types: 'Trenutno nema tipova dokumenata.',
    add_document_type: 'Dodaj tip dokumenta',
    document_type_name_placeholder: 'npr. Akreditacija',
    certificate_image: 'Slika',
    document_types_requires_saved_entity: 'Prvo sačuvajte turnir/seminar pre dodavanja tipova dokumenata.',
    variables: 'Varijable',
    add_text_field: '+ Dodaj tekst',
    field_properties: 'Podešavanja teksta',
    text_align: 'Poravnanje',
    align_left: 'Levo',
    align_center: 'Sredina',
    align_right: 'Desno',
    font_size: 'Veličina fonta',
    text_color: 'Boja teksta',
    line_height: 'Razmak između linija',
    box_height: 'Visina okvira',
    drag_edge_to_resize: 'Prevuci gornju/donju ivicu polja da promeniš visinu okvira.',
    competitor_name: 'Ime takmičara',
    competition: 'Naziv turnira',
    place_position: 'Pozicija',
    discipline: 'Disciplina',
    category: 'Kategorija',
    role: 'Uloga',
    document_image_load_failed: 'Neuspešno učitavanje slike za',
    diploma_document_type_missing: 'Prvo napravite tip dokumenta "Diploma" (u panelu Sertifikati) da biste štampali diplome pobednika.',
    print_manually: 'Ručni unos',
    parse_rows: 'Učitaj redove',
    scoring: 'Bodovanje',
    first_place_points: 'Prvo mesto',
    second_place_points: 'Drugo mesto',
    third_place_points: 'Treće mesto',
    fourth_place_points: 'Četvrto mesto',
    other_placements_points: 'Učešće',
    diplomas: 'Diplome',
    diploma_requires_placement: 'Za diplome je potreban bar jedan dodeljen plasman u žrebu.',
    winner_diplomas: 'Diplome',
    diplomas_all_competitors: 'Diplome za sve takmičare',
    assign_placements_diplomas: 'Dodela plasmana za diplome svim takmičarima.',
    assign_placements_intro: 'Dodelite plasman svakom takmičaru. Samo takmičari sa dodeljenim plasmanom dobiće diplomu.',
    certificate_type: 'Tip sertifikata',
    certificate_target: 'Za koga',
    thank_you_letter: 'Zahvalnica',
    certificate_text_competitor: 'Ovaj sertifikat potvrđuje učešće na turniru.',
    certificate_text_club: 'Ovaj sertifikat potvrđuje učešće sportskog udruženja na turniru.',
    diploma_text_competitor: 'Ovaj dokument potvrđuje učešće na turniru.',
    diploma_text_club: 'Ovaj dokument potvrđuje učešće sportskog udruženja na turniru.',
    thank_you_text_competitor: 'Zahvaljujemo se na učešću na turniru.',
    thank_you_text_club: 'Zahvaljujemo se sportskom udruženju na učešću na turniru.',
    acknowledgement: 'Zahvalnica',
    accreditation: 'Akreditacija',
    acknowledgements: 'Priznanja',
    files_and_images: 'Dokumenti i slike',
    registered_referees: 'Prijavljene sudije',
    registered_officials: 'Prijavljeni zvaničnici',
    registered_coaches: 'Prijavljeni treneri',
    register_referee: 'Prijavi sudiju',
    register_coach: 'Prijavi trenera',
    register_official: 'Prijavi zvaničnika',
    disciplines_are_visible: 'Discipline su vidljive',
    disciplines_are_hidden: 'Discipline su skrivene',
    add_club_deduction: 'Dodaj popust za sportsko udruženje',
    no_additional_info: 'Nema dodatnih informacija',
    charge_all_disciplines: 'Naplati sve discipline',
    show_category_based: 'Prikaži samo takmičare prikladne za izabranu kategoriju',
    youngest_competitor: 'Najmlađi takmičar',
    oldest_competitor: 'Najstariji takmičar',
    club_with_most_competitors: 'Sportsko udruženje sa najviše takmičara',
    club_with_most_individual_disciplines: 'Sportsko udruženje sa najviše pojedinačnih disciplina',
    club_with_most_team_disciplines: 'Sportsko udruženje sa najviše ekipnih disciplina',
    brackets: 'Žrebovi',
    bracket: 'Žreb',
    generate_draw: 'Generiši žreb',
    generate_missing_draws: 'Generiši nedostajuće žrebove',
    generate_missing_draws_warning: 'Biće generisani žrebovi samo za discipline koje još nemaju žreb (npr. naknadno dodati takmičari). Postojeći žrebovi i rezultati ostaju netaknuti. Nastaviti?',
    missing_draws_generated: 'Generisano novih žrebova: {count}',
    bracket_generation_warning: 'Nakon generisanja žreba, neće biti moguće menjati ili ponovo generisati žreb. Da li ste sigurni da želite da nastavite?',
    bracket_generation_requires_closed_registrations: 'Žreb se može generisati samo nakon zatvaranja prijava.',
    no_brackets_generated: 'Žreb još nije generisan.',
    brackets_generated_successfully: 'Žreb je uspešno generisan.',
    bracket_generation_failed: 'Greška pri generisanju žreba.',
    reset_brackets: 'Obriši žreb',
    bracket_reset_warning: 'Ovo će trajno obrisati sve podatke o žrebovima (mečevi i žrebovi) za ovaj turnir. Ova akcija se ne može poništiti. Da li ste sigurni da želite da nastavite?',
    brackets_reset_successfully: 'Žrebovi su uspešno resetovani.',
    bracket_reset_failed: 'Greška pri resetovanju žrebova.',
    print_bracket: 'Štampaj žreb',
    print_brackets: 'Štampaj žrebove',
    lock_bracket: 'Zaključaj žreb',
    lock_brackets: 'Zaključaj žrebove',
    unlock_bracket: 'Otključaj žreb',
    unlock_brackets: 'Otključaj žrebove',
    bracket_locked: 'Žreb zaključan',
    bracket_unlocked: 'Žreb otključan',
    bracket_lock_warning: 'Nakon zaključavanja žreba, biće moguće uneti rezultate mečeva. Da li ste sigurni da želite da zaključate žreb?',
    brackets_lock_warning: 'Zaključajte sve žrebove i omogućite unos rezultata mečeva?',
    bracket_unlock_warning: 'Nakon otključavanja žreba, neće biti moguće uneti rezultate mečeva. Postojeći podaci neće biti obrisani. Da li ste sigurni da želite da otključate žreb?',
    brackets_unlock_warning: 'Otključajte sve žrebove? Unos rezultata mečeva će biti onemogućen.',
    bracket_locked_successfully: 'Žreb je uspešno zaključan.',
    brackets_locked_successfully: 'Žrebovi su uspešno zaključani.',
    bracket_unlocked_successfully: 'Žreb je uspešno otključan.',
    brackets_unlocked_successfully: 'Žrebovi su uspešno otključani.',
    bracket_lock_failed: 'Greška pri zaključavanju žreba.',
    brackets_lock_failed: 'Greška pri zaključavanju žrebova.',
    bracket_unlock_failed: 'Greška pri otključavanju žreba.',
    brackets_unlock_failed: 'Greška pri otključavanju žrebova.',
    award_participation_points: 'Dodeli poene za učešće',
    participation_points_awarded: 'Poeni za učešće su uspešno dodeljeni takmičarima.',
    participation_points_award_failed: 'Greška pri dodeli poena za učešće.',
    cannot_reopen_registrations_bracket_exists: 'Ne možete ponovo otvoriti prijave jer je žreb već generisan.',
    lock_bracket_to_enter_results: 'Zaključajte žrebove da biste počeli unos rezultata mečeva.',
    club_information: 'Informacije o klubovima',
    basic_information: 'Osnovne informacije',
    individual_disciplines: 'Pojedinačne discipline',
    select_category: 'Izaberi kategoriju',
    select_discipline: 'Izaberi disciplinu',
    judges: 'Sudije',
    winner: 'Pobednik',
    edit_winner: 'Izmena pobednika',
    select_winner: 'Izaberite pobednika',
    choose_winner: 'Izaberite takmičara',
    current_winner: 'Trenutni pobednik',
    no_final_match: 'Nema finalne meča',
    save_winner_failed: 'Greška pri čuvanju pobednika',
    draw: 'Žreb',
    regenerate_draw: 'Regeneriši žreb',
    scoring_table_regenerated: 'Redosled u tabeli bodovanja je regenerisan.',
    no_competitors_in_bracket: 'Nema takmičara u ovom žrebu.',
    draw_model: 'Model žreba',
    draw_model_skeleton: 'Kostur',
    general_overall_ranking: 'Generalni plasman',
    eliminations: 'Eliminacije',
    unknown: 'Nepoznato',
    match: 'Meč',
    winner_of_match: 'Pobednik meča',
    recorder: 'Zapisničar',
    verified_by: 'Kontrolisao',
    chief_judge: 'Glavni sudija'
  },

  seminar: {
    seminar_name: 'Naziv seminara',
    seminar: 'Seminar',
    camp: 'Kamp',
    seminars_and_camps: 'Seminari i kampovi',
    create_seminar: 'Napravi',
    type_placeholder: 'Izaberi tip',
    applications: 'Prijave',
    registered_participants: 'Prijavljeni učesnici',
    register_participant: 'Prijavi učesnika',
    select_members: 'Izaberite članove',
    assign_positions: 'Dodeli uloge',
    assign_positions_per_participant: 'Dodeli uloge po učesniku',
    edit_positions: 'Izmeni uloge',
    positions: 'Uloge',
    number_of_registered_participants: 'Broj prijavljenih učesnika',
    Judge: 'Sudija',
    Athlete: 'Takmičar',
    'Judge Trainee': 'Sudijski pripravnik',
    Instructor: 'Instruktor',
    Examiner: 'Ispitivač',
    'Sports Official': 'Sportski radnik',
    Companion: 'Pratilac',
    Coach: 'Trener',
    already_registered: 'Već prijavljen'
  },

  club: {
    club_name: 'Naziv sportskog udruženja',
    short_name: 'Skraćeni Naziv Sportske Organizacije',
    member: 'Član sportskog udruženja | Članovi sportskog udruženja',
    my_federation_information: 'Informacije sportskog udruženja',
    coach: 'Trener | Treneri',
    official: 'Zvaničnik | Zvaničnici',
    referee: 'Sudija | Sudije',
    referee_rang: 'Rang sudije',
    add_official: 'Dodaj zvaničnika',
    edit_official: 'Izmeni zvaničnika',
    add_member: 'Dodaj člana',
    ask_delete_club: 'Da li si siguran da želiš da ukloniš ovo udruženje',
    ask_undelete_club: 'Da li si siguran da želiš da vratiš ovo udruženje',
    active_clubs: 'Aktivna',
    deleted_clubs: 'Arhiva',
    undelete: 'Vrati',
    ask_delete_official: 'Da li si siguran da želiš da ukloniš zvaničnika',
    registration_fee_free: 'Oslobođen/a kotizacije',
    must_pay_registration_fee: 'Obavezna kotizacija',
    cost_reduction: 'Popust na kotizaciju',
    number_of_competitors: 'Broj takmičara'
  },

  profile: {
    my_profile: 'Moj profil',
    profile_settings: 'Podešavanja profila',
    change_password: 'Promeni lozinku',
    current_password: 'Trenutna lozinka',
    new_password: 'Nova lozinka'
  },

  settings: {
    settings: 'Podešavanja',
    category: 'Kategorija | Kategorije',
    discipline: 'Disciplina | Discipline',
    allowed_sexes: 'Dozvoljeni polovi',
    general_settings: 'Generalna podešavanja',
    website_name: 'Naziv web sajta',
    website_description: 'Opis web sajta',
    logo: 'Logo',
    create_category: 'Napravi kategoriju',
    create_discipline: 'Napravi disciplinu',
    edit_discipline: 'Izmeni disciplinu',
    edit_category: 'Izmeni kategoriju',
    one_discipline: 'Jedna disciplina',
    two_disciplines: 'Dve discipline',
    three_disciplines: 'Tri discipline',
    four_or_more_disciplines: 'Četiri i više disciplina',
    three_or_more_disciplines: 'Tri ili više disciplina',
    team_disciplines: 'Ekipne discipline',
    discipline_always_chargeable: 'Ova disciplina se uvek naplaćuje',
    discipline_not_chargeable: 'Ova disciplina se ne naplaćuje',
    category_not_chargeable: 'Ova kategorija se ne naplaćuje',
    disable_edit: 'Onemogući izmenu',
    disable_create: 'Onemogući kreiranje',
    this_is_kata_a: 'Ova je Kata A',
    this_is_kata_b: 'Ova je Kata B',
    number_of_podium_places: 'Broj mesta na postolju',
    podium_places_3: '3 mesta na postolju (1., 2., 3.)',
    podium_places_4: '4 mesta na postolju (1., 2., 3., 4. / dve bronze)',
    reset_points_title: 'Resetovanje poena i medalja',
    reset_points_help: 'Postavlja sve osvojene poene i medalje klubova i takmičara na nulu. Turniri, bracket-i i meč rezultati se ne menjaju, ali rang lista po turnirima više neće prikazivati osvojene poene za prethodne turnire.',
    reset_points_button: 'Resetuj poene i medalje'
  },

  messages: {
    success_sign_in: 'Uspešno ste se prijavili.',
    error_email_password_combination: 'Pogresna email adresa ili lozinka.',
    success_register: 'Uspešno ste se registrovali. Možete se prijaviti',
    settings_successfully_updated: 'Podešavanja uspešno sačuvana.',
    ask_reset_points: 'Da li ste sigurni da želite da resetujete sve poene i medalje klubova i takmičara? Turniri i bracket-i ostaju nepromenjeni.',
    points_successfully_reset: 'Svi poeni i medalje su uspešno resetovani.',
    success_remove_discipline: 'Disciplina je obrisana uspešno.',
    success_remove_category: 'Kategorija je obrisana uspešno.',
    ask_delete_official: 'Da li si siguran da želiš da ukloniš zvaničnika',
    ask_delete_tournament: 'Da li si siguran da želiš da obrišeš ovaj turnir?',
    ask_delete_seminar: 'Da li si siguran da želiš da obrišeš ovaj seminar?',
    ask_delete_camp: 'Da li si siguran da želiš da obrišeš ovaj kamp?',
    ask_remove_discipline:
      'Da li ste sigurni da želite da obrišete ovu disciplinu',
    ask_remove_category:
      'Da li ste sigurni da želite da obrišete ovu kategoriju',
    ask_remove_coach: 'Da li ste sigurni da želite da obrišete trenera',
    ask_remove_team: 'Da li ste sigurni da želite da obrišete ovaj savez',
    ask_remove_referee: 'Da li ste sigurni da želite da obrišete sudiju',
    ask_assign_numbers:
      'Da li ste sigurni da želite da dodelite brojeve takmičarima?',
    success_updated_referee: 'Uspešno ste izmenili sudiju.',
    success_created_referee: 'Uspešno ste dodali sudiju.',
    success_updated_official: 'Uspešno ste izmenili zvaničnika.',
    success_created_official: 'Uspešno ste dodali zvaničnika.',
    success_updated_discipline: 'Disciplinaje je izmenjena uspešno.',
    success_created_discipline: 'Disciplina je napravljena uspešno.',
    success_updated_category: 'Kategorija je izmenjena uspešno.',
    success_created_category: 'Kategorija je napravljena uspešno.',
    success_updated_profile: 'Profil je izmenjen uspešno.',
    success_changed_password: 'Lozinka uspešno promenjena.',
    success_deleted_tournament: 'Uspešno ste uklonili turnir.',
    success_deleted_seminar: 'Uspešno ste uklonili seminar.',
    success_deleted_camp: 'Uspešno ste uklonili kamp.',
    success_deleted_team: 'Uspešno ste uklonili ekipu.',
    success_deleted_referee: 'Uspešno ste uklonili sudiju.',
    success_deleted_club: 'Uspešno ste uklonili sportsko udruženje.',
    success_restored_club: 'Uspešno ste vratili sportsko udruženje.',
    success_deleted_official: 'Uspešno ste uklonili zvaničnika.',
    success_deleted_coach: 'Uspešno ste uklonili sudiju.',
    success_updated_coach: 'Uspešno ste izmenili trenera.',
    success_created_coach: 'Uspešno ste dodali trenera.',
    success_forgot_password_request:
      'Uspešno ste poslali zahtev za resetovanje lozinke. Proverite vaš email.',
    error_unknown: 'Došlo je do greške. Molimo vas pokušajte ponovo.',
    error_unknown_account_email: 'Ne postoji nalog sa unetom email adresom.',
    success_reset_password:
      'Uspešno ste resetovali lozinku. Možete se prijaviti.',
    success_assign_numbers: 'Uspešno ste dodelili brojeve takmičarima.',
    error_enter_at_least_one_discipline: 'Morate uneti barem jednu disciplinu.',
    success_updated_competitor: 'Uspešno ste izmenili takmičara.',
    success_registered_competitor: 'Uspešno ste prijavili takmičara.',
    ask_remove_competitor: 'Da li si siguran da želiš da ukloniš takmičara',
    success_remove_competitor: 'Uspešno ste uklonili takmičara.',
    error_number_of_selected_competitors:
      'Broj izabranih takmičara mora biti 2, 3 ili 4.',
    error_select_at_least_one_discipline:
      'Morate uneti barem jednu disciplinu.',
    success_updated_team: 'Uspešno ste izmenili tim.',
    success_registered_team: 'Uspešno ste prijavili tim.',
    success_updated_member: 'Uspešno ste izmenili člana.',
    success_created_member: 'Uspešno ste dodali člana.',
    insurance_document_required: 'Potrebno je priložiti dokument osiguranja jer je datum izmenjen.',
    medical_document_required: 'Potrebno je priložiti dokument lekarskog pregleda jer je datum izmenjen.',
    ask_archive_tournament: 'Da li si siguran da želiš da arhiviraš ovaj turnir',
    ask_archive_seminar: 'Da li si siguran da želiš da arhiviraš ovaj seminar?',
    ask_archive_camp: 'Da li si siguran da želiš da arhiviraš ovaj kamp?',
    ask_unarchive_tournament: 'Da li si siguran da želiš da aktiviraš ovaj turnir',
    ask_archive_category: 'Da li si siguran da želiš da arhiviraš ovu kategoriju',
    ask_unarchive_category: 'Da li si siguran da želiš da aktiviraš ovu kategoriju',
    ask_archive_discipline: 'Da li si siguran da želiš da arhiviraš ovu disciplinu',
    ask_unarchive_discipline: 'Da li si siguran da želiš da aktiviraš ovu disciplinu',
    success_archived_tournament: 'Uspešno si arhivirao turnir.',
    success_archived_seminar: 'Uspešno si arhivirao seminar.',
    success_archived_camp: 'Uspešno si arhivirao kamp.',
    success_unarchived_tournament: 'Uspešno si aktivirao turnir.',
    success_archived_category: 'Uspešno si arhivirao kategoriju.',
    success_unarchived_category: 'Uspešno si aktivirao kategoriju.',
    success_archived_discipline: 'Uspešno si arhivirao disciplinu.',
    success_unarchived_discipline: 'Uspešno si aktivirao disciplinu.',
    success_blocked_user: 'Uspešno si blokirao korisnika.',
    success_unblocked_user: 'Uspešno si odblokirao korisnika.',
    success_set_as_admin: 'Uspešno si postavio kao admina.',
    success_remove_as_admin: 'Uspešno si uklonio admina.',
    success_registered_referee: 'Uspešno si prijavio sudiju.',
    success_removed_referee: 'Uspešno si uklonio sudiju.',
    success_registered_coach: 'Uspešno si prijavio trenera.',
    success_removed_coach: 'Uspešno si uklonio trenera.',
    success_registered_official: 'Uspešno si prijavio zvaničnika.',
    success_removed_official: 'Uspešno si uklonio zvaničnika.',
    success_created_club_deduction: 'Uspešno si kreirao popust za sportsko udruženje.',
    ask_remove_club_deduction: 'Da li si siguran da želiš da ukloniš popust za sportsko udruženje',
    success_activated_member: 'Uspešno ste aktivirali člana.',
    success_deactivated_member: 'Uspešno ste deaktivirali člana.'
  },

  validation: {
    required: 'Ovo polje je obavezno.',
    isTruthy: 'Ovo polje je obavezno.',
    email: 'Unesite ispravnu email adresu.',
    integer: 'Polje mora biti broj.',
    url: 'Unesite ispravnu URL adresu.',
    minLength: 'Broj karaktera mora biti veći.',
    sameAsPassword: 'Lozinke se ne poklapaju.',
    ageFromLessThanAgeTo: 'Godina rođenja mora biti manja od godine rođenja.',
    ageToGreaterThanAgeFrom: 'Godina rođenja mora biti veća od godine rođenja.'
  },

  changes: {
    REGISTER_COMPETITOR: 'je prijavio takmičara',
    COMPETITOR_UPDATE: 'je izmenio takmičarsku prijavu',
    COMPETITOR_DELETE: 'je obrisao takmičara',
    REGISTER_TEAM: 'je prijavio ekipu',
    TEAM_UPDATE: 'je izmenio ekipu',
    TEAM_DELETE: 'je obrisao ekipu',
    REGISTER_REFEREE: 'je prijavio sudiju',
    REGISTER_COACH: 'je prijavio trenera',
    REGISTER_OFFICIAL: 'je prijavio zvaničnika',
    REFEREE_DELETE: 'je obrisao sudiju',
    COACH_DELETE: 'je obrisao trenera',
    OFFICIAL_DELETE: 'je obrisao zvaničnika',
    TOURNAMENT_ARCHIVED: 'je arhivirao turnir',
    REGISTER_PARTICIPANT: 'je prijavio učesnika',
    REMOVE_PARTICIPANT: 'je obrisao učesnika',
    UPDATE_PARTICIPANT: 'je izmenio učesnika'
  },

  referee_rangs: {
    NATIONAL_A: 'Nacionalni A',
    NATIONAL_B: 'Nacionalni B',
    NATIONAL_C: 'Nacionalni C',
    NATIONAL_D: 'Nacionalni D',
    INTEARNATIONAL_A: 'Internacionalni A',
    INTEARNATIONAL_B: 'Internacionalni B',
    INTEARNATIONAL_C: 'Internacionalni C',
    INTEARNATIONAL_D: 'Internacionalni D',
    TRAINEE: 'Pripravnik',
    ZAPISNICAR: 'Zapisnicar',
    OTHER: 'Drugo'
  }
}
